<template>
  <v-card class="fill-height">
    <v-card-title>{{ tablesTitle }}</v-card-title>
    <v-card-subtitle>{{ tablesSubtitle }}</v-card-subtitle>
    <v-card-text>
      <v-list>
        <template
          v-for="chatAcc in chatAccounts"
        >

        <v-list-item
          :class="[getCssClass(chatAcc), 'account-card']"
          @click="setActiveAccount(chatAcc.name)" :key="chatAcc.name"
        >

          <!-- all chat suggestion -->
          <div
            class="chat-suggestion"
            v-if="canSeeChatSuggestions(chatAcc.name)"
          >
            <!-- chat suggestion -->
            <span class="normal-suggestion" v-if="chatSuggestions2(chatAcc.name).length">
              Suggested<template v-if="debug">*</template>: {{ chatSuggestions2(chatAcc.name).map(el => el.message).join(", ") }}
            </span>

            <!-- chatbot suggestion -->
            <span class="chatbot-suggestion" v-if="canSeeChatbotSuggestions(chatAcc.name)">
              Chatbot<template v-if="debug">*</template>: <span v-html="chatbotSuggestionMessageHtml(chatAcc.name)"></span>
            </span>
          </div>

          <div class="d-flex justify-center align-center" style="width: 100%">

          <!-- unread indicator -->
          <v-list-item-icon>
            <v-btn rounded small :color="colorUnread(chatAcc)">
              {{ chatAcc.unread }}
            </v-btn>
          </v-list-item-icon>

          <v-list-item-content style="overflow: hidden; position: relative; flex-grow: 1">

            <!-- icons -->
            <div style="
              position: absolute;
              top: 0;
              bottom: 0;
              right: 10px;
              display: flex;
              justify-content: center;
            ">

              <!-- priming icon -->
              <div v-if="chatAcc.priming" class="d-flex justify-center align-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-key</v-icon>
                    </v-btn>
                  </template>
                  <span>Priming</span>
                </v-tooltip>
              </div>

              <!-- contacting host icon -->
              <div v-if="chatAcc.contacting_host" class="d-flex justify-center align-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-message</v-icon>
                    </v-btn>
                  </template>
                  <span>Contacting Host</span>
                </v-tooltip>
              </div>

              <!-- buyin rejected icon -->
              <div v-if="chatAcc.buyin_state && chatAcc.buyin_state.type === 'rejected'" class="d-flex justify-center align-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-currency-usd-off</v-icon>
                    </v-btn>
                  </template>
                  <span>Buy-in Rejected</span>
                </v-tooltip>
              </div>

              <!-- claimed icon -->
              <div v-if="chatAcc.claimed" class="d-flex justify-center align-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon v-if="chatAcc.claimed_user_id === activeOperatorId">mdi-star</v-icon>
                      <v-icon v-else>mdi-star-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Claimed by {{ operatorUserName(chatAcc.claimed_user_id) }}</span>
                </v-tooltip>
              </div>

              <!-- dont leave icon -->
              <div v-if="chatAcc.operator_dont_want_to_leave" class="d-flex justify-center align-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-share-off</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    <pre style="text-align: center">{{ dontLeaveTooltipText(chatAcc) }}</pre>
                  </span>
                </v-tooltip>
              </div>

              <!-- snoozed icon -->
              <div v-if="chatAcc.snoozed" class="d-flex justify-center align-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-sleep</v-icon>
                    </v-btn>
                  </template>
                  <span>Snoozed</span>
                </v-tooltip>
              </div>

            </div>

            <!-- account name & header -->
            <v-list-item-title class="d-flex align-center">
              <span>
                <v-tooltip right v-if="bombPotInfo(chatAcc.name).enabled">
                  <template v-slot:activator="{ on }">
                    <v-btn small icon v-on="on" class="mr-1">
                      <v-icon>mdi-bomb</v-icon>
                    </v-btn>
                  </template>
                  Bomb pot: {{ bombPotInfo(chatAcc.name).bb }} bb every {{ bombPotInfo(chatAcc.name).every }} hands
                </v-tooltip>
                <v-tooltip right v-if="isOurClubPartnerBot(chatAcc.name)">
                  <template v-slot:activator="{ on }">
                    <v-btn small icon v-on="on" class="mr-1">
                      <v-icon>mdi-earth</v-icon>
                    </v-btn>
                  </template>
                  Our Club
                </v-tooltip>

                <span v-if="chatAcc.app !== 'Pkr2' && (isDev || isManager)" style="color: darkorange">
                  [{{ chatAcc.app }}]
                </span>

                <span :style="'color: ' + getNameColor(chatAcc.name)">
                  {{ chatAcc.displayID || chatAcc.name }}
                  <template v-if="chatAcc.roomId"> [{{ chatAcc.roomId }}]</template>
                </span>

                <span v-if="isTournament(chatAcc.name)"> (Tournament)</span>
                <span v-else :style="needBBColor(chatAcc.name) ? 'color: #FF5C5C' : ''">
                  <strong> {{ resultIsNegative(chatAcc.name) ? '-' : '' }}{{ currency(chatAcc.name) === 'USD' ? '$' : '' }}{{ Math.abs(result(chatAcc.name)) }} {{ currency(chatAcc.name) !== 'USD' ? currency(chatAcc.name) : '' }}</strong>
                  <span v-if="numHands(chatAcc.name) > 0"> in {{ numHands(chatAcc.name) }} hands</span>
                </span>
              </span>
            </v-list-item-title>

            <!-- 'gave warning' status -->
            <v-list-item-subtitle v-if="ras(chatAcc) && ras(chatAcc).sidebar_warning_text"
                                  class="gave-warning">
              {{ ras(chatAcc).sidebar_warning_text }}
            </v-list-item-subtitle>

            <!-- table status -->
            <v-list-item-subtitle v-if="prepareTable(chatAcc)">
              <span style="color: yellow">preparing</span>
            </v-list-item-subtitle>

            <v-list-item-subtitle v-if="tableIsPaused(chatAcc)">
              <span style="color: #54bfe3">table paused</span>
            </v-list-item-subtitle>

            <v-list-item-subtitle v-if="tableIsWaiting(chatAcc)">
              <span style="color: #54bfe3">table waiting</span>
            </v-list-item-subtitle>

            <v-list-item-subtitle v-if="ras(chatAcc) && ras(chatAcc).we_are_observing">
              <span style="color: yellow">observing</span>
            </v-list-item-subtitle>

            <v-list-item-subtitle v-if="ras(chatAcc) && ras(chatAcc).we_are_sitting_out">
              <span style="color: yellow">sitting out</span>
            </v-list-item-subtitle>

            <v-list-item-subtitle v-if="ras(chatAcc) && ras(chatAcc).waiting_for_buyin_auth">
              <span style="color: #01c100">waiting for buy-in</span>
            </v-list-item-subtitle>

            <v-list-item-subtitle v-if="ras(chatAcc) && ras(chatAcc).reload_requested">
              <span style="color: #01c100">reload requested</span>
            </v-list-item-subtitle>

            <template v-if="ras(chatAcc)">
              <!-- op alerts first -->
              <v-list-item-subtitle v-for="opAlert of ras(chatAcc).operator_alerts"
                                    style="color: #ff6a1e; font-size: 1.3em"
                                    :key="opAlert.message">
                {{ opAlert.message }}
              </v-list-item-subtitle>

              <!-- need to stand? -->
              <v-list-item-subtitle v-if="ras(chatAcc).stand_now" class="gave-warning">
                Get up now!<br>
                {{ ras(chatAcc).want_to_stand_reason }}<br>
                {{ ras(chatAcc).stand_now_reason }}
                <template v-if="ras(chatAcc).no_rewarn_reason"><br>{{ ras(chatAcc).no_rewarn_reason }}</template>
              </v-list-item-subtitle>
              <!-- need to warn? -->
              <v-list-item-subtitle v-else-if="ras(chatAcc).give_warning_now" class="gave-warning">
                Give warning now!<br>
                {{ ras(chatAcc).want_to_stand_reason }}<br>
                <!-- only show the reason if it's not the 'always' rule -->
                {{ ras(chatAcc).give_warning_reason.indexOf('always') == -1 ? ras(chatAcc).give_warning_reason : '' }}
              </v-list-item-subtitle>
            </template>

            <v-list-item-subtitle v-if="queueStatus(chatAcc)">
              <span style="color: yellow">{{ queueStatus(chatAcc) }}</span>
            </v-list-item-subtitle>

            <!-- contacting host -->
            <v-list-item-subtitle v-if="chatAcc.contacting_host">
              <span style="color: #00deff">{{ contactingHostMessage(chatAcc) }}</span>
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="!chatAcc.contacting_host && chatAcc.contacting_host_not_available">
              <span style="color: #f00">not available to contact host</span>
            </v-list-item-subtitle>

            <!-- buyin rejected -->
            <v-list-item-subtitle v-if="chatAcc.buyin_state && chatAcc.buyin_state.type === 'rejected'">
              <span style="color: #00deff">{{ buyinRejectedMessage(chatAcc) }}</span>
            </v-list-item-subtitle>

            <!-- debug -->
            <v-list-item-subtitle v-if="debug && automationStateFor(chatAcc.name)" :set="as = automationStateFor(chatAcc.name)">
              <!-- what i debug now -->
              <template v-if="!as.want_to_sit_out_reason.includes('won\'t sit out this session')">
                Sit Out Session
                  <template v-if="as && as.debug2 && as.debug2.in_sit_out_break_window">(in break window)</template>
                  <template v-else>(not in break window)</template>
                <br>
                {{ as.want_to_sit_out_reason }}<br>
                {{ as.sit_out_now_reason }}<br>
              </template>
              <template v-if="as.we_are_sitting_out">
                Sitting Out
                {{ as.want_to_sit_back_reason }}<br>
                {{ as.sit_back_now_reason }}<br>
              </template>

              <!-- debug icons -->
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" style="display: inline">
                    <v-icon>mdi-account-box-outline</v-icon>
                  </v-btn>
                </template>
                <pre>{{ chatAcc }}</pre>
              </v-tooltip>
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" style="display: inline" @click="openDebugAs(chatAcc)">
                    <v-icon>mdi-bug</v-icon>
                  </v-btn>
                </template>
                Updated {{ asSecsAgo(chatAcc) }}s ago<br>
                <pre>{{ as }}</pre>
              </v-tooltip>
            </v-list-item-subtitle>

            <!-- always show errors to claud -->
            <template v-if="isClaud && automationStateFor(chatAcc.name) && automationStateFor(chatAcc.name).have_automation_error">
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon color="red">mdi-alert</v-icon>
                  </v-btn>
                </template>
                Automation Errors:
                <template v-for="err in automationStateFor(chatAcc.name).automation_errors">
                  - {{ err }}
                </template>
              </v-tooltip>
            </template>

          </v-list-item-content>

          </div>


          <div class="extra-bottom" v-if="canSeeExtraBottom(chatAcc.name)">

            <span class="talk-more" v-if="mgmtAccount(chatAcc.name).talk_more">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">should talk more</span>
                </template>
                <span>{{ mgmtAccount(chatAcc.name).talk_more_instructions }}</span>
              </v-tooltip>
            </span>

          </div>

        </v-list-item>

        </template>
      </v-list>
    </v-card-text>

    <v-dialog v-model="showDebugAs" width="500">
      <v-card>
        <v-card-title>Automation State ({{ asSecsAgo(showDebugAcc) }}s ago) - {{ showDebugAcc.name }}</v-card-title>
        <v-card-text>
          <pre>{{ automationStateFor(showDebugAcc.name) }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  data() {
    return {
      selected: null,

      showDebugAs: false,
      showDebugAcc: {}
    };
  },
  computed: {

    tablesTitle() {
      let totalCount = this.chatAccounts.length;
      let title = `${totalCount} Tables`;
      return title;
    },
    tablesSubtitle() {
      let title = ``;

      let activeCount = 0;
      let queueCount = 0;
      let waitingCount = 0;
      let preparingCount = 0;
      let observingCount = 0;

      for (let acc of this.chatAccounts) {
        let isQueue = this.queueStatus(acc);
        let isWaiting = this.tableIsWaiting(acc);
        let isPrepare = this.prepareTable(acc);
        let isObserving = this.ras(acc) && this.ras(acc).we_are_observing;

        if (isQueue) {
          queueCount += 1;
        }

        if (isWaiting) {
          waitingCount += 1;
        }

        if (isPrepare) {
          preparingCount += 1;
        }

        if (isObserving) {
          observingCount += 1;
        }

        if (!isQueue && !isWaiting && !isPrepare && !isObserving) {
          activeCount += 1;
        }
      }

      title += `${activeCount} Active`;

      if (observingCount > 0) {
        title += ` | ${observingCount} Observing`;
      }

      if (queueCount > 0) {
        title += ` | ${queueCount} On Queue`;
      }

      if (waitingCount > 0) {
        title += ` | ${waitingCount} Waiting`;
      }

      if (preparingCount > 0) {
        title += ` | ${preparingCount} Preparing`;
      }

      return title;
    },

    ...mapGetters([
      'ourPlayer',
      'accountState',
      'messagesForUser',
      'unreadMessages',
      'activeChatAccountName',
      'result',
      'chatAccounts',
      'roomQueue',
      'gameType',
      'bombPotInfo',
      'chatSuggestions2',
      'chatbotSuggestions',
      'opponents',
      'isClaud',
      'isDev',
      'isManager',
      'isChatbotManager',
      'clubmgmAccountByName',
      'activeOperatorId',
      'operatorUserName',
      'automationStateFor',
    ]),
    ...mapState([
      'debug',
    ])
  },
  methods: {

    chatbotSuggestionMessageHtml(name) {
      let suggestions = this.chatbotSuggestions(name);

      if (!suggestions.length) {
        return '';
      }

      if (suggestions.length > 1) {
        return `${suggestions[0].message} <span class="black--text font-weight-bold ml-1">(+${suggestions.length - 1})</span>`;
      }

      return suggestions[0].message;
    },

    canSeeChatbotSuggestions(name) {
      // if we're a chatbot manager, we can see all suggestions
      if (this.isChatbotManager) {
        return this.chatbotSuggestions(name).length > 0;
      }

      return false;
    },

    canSeeExtraBottom(name) {
      let mgmtAcc = this.clubmgmAccountByName(name);
      if (!mgmtAcc) return false;
      // for now only talk_more
      return mgmtAcc.talk_more;
    },

    canSeeChatSuggestions(name) {
      let hasSuggestions = this.chatSuggestions2(name).length > 0;

      // if we're a chatbot manager, we can see all suggestions
      if (this.isChatbotManager) {
        return hasSuggestions || this.chatbotSuggestions(name).length;
      }

      return hasSuggestions;
    },

    queueStatus(acc) {
      if (!this.roomQueue) return false;
      if (!(acc.name in this.roomQueue)) return false;
      if (!this.roomQueue[acc.name]) return false;
      if (!("queue_status" in this.roomQueue[acc.name])) return false;
      return this.roomQueue[acc.name].queue_status;
    },

    colorUnread(acc) {
      if (acc.unread === 0) {
        // nothing unread
        return 'secondary';
      }

      // ignoring chats, light gray
      let as = this.ras(acc);
      if (as && as.ignore_chats) {
        return 'grey lighten-1';
      }

      // dont ignore the chats
      return 'primary';
    },

    buyinRejectedMessage(acc) {
      let buyinState = acc.buyin_state || {};

      for (let k of Object.keys(buyinState.contacting_users)) {
        if (buyinState.contacting_users[k].action === 'handling') {
          return `${buyinState.contacting_users[k].name || 'Manager'} handling buy-in rejected...`
        }
      }

      if (Object.keys(buyinState.contacting_users).length > 1) {
        return 'Contacting group...'
      }

      let managerName = 'manager';
      for (let k of Object.keys(buyinState.contacting_users)) {
        if (buyinState.contacting_users[k].name) {
          managerName = buyinState.contacting_users[k].name;
          break;
        }
      }

      return `Contacting ${managerName}...`
    },

    contactingHostMessage(acc) {
      for (let k of Object.keys(acc.contacting_host_users)) {
        if (acc.contacting_host_users[k].action === 'handling') {
          return `${acc.contacting_host_users[k].name || 'Manager'} handling contact...`
        }
      }

      if (Object.keys(acc.contacting_host_users).length > 1) {
        return 'Contacting group...'
      }

      let managerName = 'manager';
      for (let k of Object.keys(acc.contacting_host_users)) {
        if (acc.contacting_host_users[k].name) {
          managerName = acc.contacting_host_users[k].name;
          break;
        }
      }

      return `Contacting ${managerName}...`
    },
    prepareTable(acc) {
      let name = acc.name;
      let st = this.accountState(name);

      return st && st.room && st.room.status === 'PREPARE';
    },
    tableIsPaused(acc) {
      let name = acc.name;
      let st = this.accountState(name);

      return st && st.room && st.room.status === 'PAUSE';
    },
    tableIsWaiting(acc) {
      let name = acc.name;
      let st = this.accountState(name);

      return st && st.room && st.room.status === 'WAITING';
    },
    setActiveAccount(name) {
      this.$store.commit("setActiveChatAccount", name);
    },
    numHands(name) {
      let st = this.accountState(name);
      if (st && st.hands_played) {
        return st.hands_played;
      }
      return 0;
    },
    bb(name) {
      let d = 1;
      let st = this.accountState(name);
      if (!st || !st.settings) return 0;
      if (st.settings.withDecimal) {
        d = 100;
      }
      return st.settings.bb / d;
    },
    mgmtAccount(name) {
      return this.clubmgmAccountByName(name) || {};
    },
    club(name) {
      return (this.clubmgmAccountByName(name) || {}).club;
    },
    isOurClubPartnerBot(name) {
      if (!((this.club(name) || {}).is_our)) {
        // not our club
        return false;
      }

      if (!((this.clubmgmAccountByName(name) || {}).is_partner_bot)) {
        // not partner bot
        return false;
      }

      return true;
    },
    currency(name) {
      return (this.club(name) || {}).currency || 'USD?';
    },
    needBBColor(name) {
      let currency = this.currency(name);

      if (currency === "USD") {
        return this.bb(name) >= 10;
      } else if (currency === "NOK") {
        return this.bb(name) >= 75;
      } else {
        return false;
      }
    },
    resultIsNegative(name) {
      return this.result(name) < 0;
    },
    isTournament(name) {
      let st = this.accountState(name);
      if (!st) return false;
      if (!("settings" in st)) return false;
      if (!st.settings) return false;
      return "prizePlan" in st.settings && !(st.settings.rummy);
    },
    accountShouldFlash(acc) {
      if (acc.snoozed) {
        return false;
      }
      if (acc.priming) {
        return false;
      }

      if (acc.claimed) {
        // only flash if op is claimed-by user
        return acc.claimed_user_id === this.activeOperatorId;
      }

      return true;

    },
    getCssClass(acc) {
      let name = acc.name;

      let extra = "";

      if (this.canSeeChatSuggestions(name)) {
        extra = "suggested";
      }

      if (this.canSeeExtraBottom(name)) {
        extra += " has-extra-bottom";
      }

      // -------- new automation logic --------
      let as = this.automationStateFor(acc.name);
      if (as && this.accountShouldFlash(acc)) {
        if (as.stand_now) {
          return 'warn-stand-now ' + extra;
        }

        if (as.give_warning_now) {
          return 'warn-warn-now ' + extra;
        }

        if (as.operator_alerts.length > 0) {
          return 'warn-operator-alert ' + extra;
        }
      }

      if (this.activeChatAccountName === name) {
        return 'active ' + extra
      }

      return '' + extra;
    },

    getNameColor(name) {
      let gt = this.gameType(name);

      if (gt === "ofc") {
        return "#0FC6FE";
      } else if (gt === "plo6") {
        return "#ee9c40";
      } else if (gt === "plo5") {
        return "#eedd19";
      } else if (gt === 'roe') {
        return '#008f00'
      }

      return "#fff";
    },

    dontLeaveTooltipText(acc) {
      if (!acc) return '';
      if (!acc.operator_dont_want_to_leave) return '';

      let data = acc.operator_dont_want_to_leave;
      let text = "Marked don't want to leave";

      if (data.leave_after_type == 'hands') {
        text += ` until hand #${data.leave_after_value}`;
      } else {
        let dataTs = data.leave_after_value;
        let nowTs = new Date().getTime() / 1000;
        let minutesBetween = (dataTs - nowTs) / 60;

        text += ` for the next ${Math.ceil(minutesBetween)} minute(s)`;
      }

      text += '\n';
      text += `Reason: ${data.reason}`;

      return text;
    },

    // short-hand for template
    ras(acc) {
      if (!acc) {
        return null;
      }

      return this.automationStateFor(acc.name);
    },

    asSecsAgo(acc) {
      if (!acc) {
        return 0;
      }

      let as = this.automationStateFor(acc.name);

      if (!as) {
        return 0;
      }

      return (Date.now()/1000 - (as.ran_timestamp || 0)).toFixed(0);
    },

    openDebugAs(acc) {
      this.showDebugAs = true;
      this.showDebugAcc = {...acc};
    }
  }
}
</script>

<style scoped>
.active {
  background-color: rgb(47, 49, 49) !important;
  border: 1px solid rgb(138, 138, 138);
}
.snoozed {
  background-color: rgb(120, 138, 138) !important;
  border: 1px solid rgb(94, 93, 93);
}
.account-card {
  border-radius: 16px !important;
  margin-bottom: 5px;

  flex-direction: column;
  min-height: 0;
}
.account-card::before {
  border-radius: 16px !important;
}
.account-card .v-list-item__content {
  padding-bottom: 4px;
}

.v-card {
  /*height: 55vh !important;*/
  /*max-height: 55vh;*/
  height: 100% !important;
  overflow-y: auto;
}

@keyframes anim-warn-now {
  /*0%   {background-color: rgb(37, 45, 206);}*/
  50%  {background-color: rgb(61, 127, 255);}
  /*100% {background-color: rgb(37, 59, 206);}*/
}

@keyframes anim-stand-now {
  0%   {background-color: #1e1e1e; color: white;}
  50%  {background-color: #e33e3e; color: black;}
  100% {background-color: #1e1e1e; color: white;}
}

@keyframes anim-operator-alert {
  0%   {background-color: #1e1e1e; color: white;}
  50%  {background-color: #4e013d; color: white;}
  100% {background-color: #1e1e1e; color: white;}
}

.warn-warn-now {
  animation-name: anim-warn-now;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  color: white !important;
  font-weight: bold;
}

.warn-stand-now {
  animation-name: anim-stand-now;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  color: black;
  font-weight: bold;
}

.warn-operator-alert {
  animation-name: anim-operator-alert;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  color: black;
  font-weight: bold;
}


@keyframes anim2 {
  /*0%   {background-color: rgb(37, 45, 206);}*/
  50%  {background-color: rgb(0, 127, 0);}
  /*100% {background-color: rgb(37, 59, 206);}*/
}

@keyframes anim2-red {
  0%   {background-color: #1e1e1e; color: white;}
  50%  {background-color: #e3ff3e; color: black;}
  100% {background-color: #1e1e1e; color: white;}
}

.warn2 {
  animation-name: anim2;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  color: white !important;
  font-weight: bold;
}

.warn2-red {
  animation-name: anim2-red;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  color: black;
  font-weight: bold;
}

.gave-warning {
  color: orange !important;
  font-weight: bold;
}

.v-list-item__icon {
  margin-right: 8px !important;
}

.suggested {
  margin-top: 24px;
}

.has-extra-bottom {
  margin-bottom: 24px;
}

.extra-bottom {
  gap: 2px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  color: white !important;

  font-weight: 900;

  padding: 4px;
  width: 100%;

  position: relative;

  bottom: 0;
  right: 0;
  left: 0;

  margin-top: -28px;
}

.extra-bottom > span {
  margin: 0;
  padding: 0;
  border-radius: 8px;
  padding: 0 8px;
  overflow: hidden;

  position: relative;

  bottom: -18px;
  right: -28px;

  white-space: break-spaces;
}

.talk-more {
  background-color: #61876E;
  border: 2px solid #3C6255;
}

.chat-suggestion {
  gap: 2px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  color: white !important;

  font-weight: 900;

  padding: 4px;
  width: 100%;

  position: relative;

  top: 0;
  right: 0;
  left: 0;

  margin-bottom: -28px;
}

.chat-suggestion > span {
  margin: 0;
  padding: 0;
  border-radius: 8px;
  padding: 0 8px;
  overflow: hidden;

  position: relative;

  top: -18px;
  right: -28px;

  white-space: break-spaces;
}

.normal-suggestion {
  background-color: #176f95;
  border: 2px solid #0f4e6d;
}

.chatbot-suggestion {
  background-color: darkorange;
  border: 2px solid #a05d00;
}

</style>
